<template>
  <div role="tablist" :class="['sku-color']" ref="scrollBox" v-if="items && items.length">
    <template v-for="(item, index) in items">
      <div
        class="item_wrapper"
        :class="['color-item-' + index]"
        v-if="isExist(index + 1)"
        @click="selectColor(index, item.name)"
        :key="item.name + index"
        tabindex="0"
        :aria-label="`${index == checkedSpecItemId - 1 ? '已选中' : '未选中'},${item.name}`"
      >
        <div
          class="item_bg"
          :class="{
            'item_bg--active': index == checkedSpecItemId - 1,
            'item_bg--gray': isNoStore(index + 1)
          }"
        >
          <span
            class="color_item"
            :style="{
              'background-image': `linear-gradient(to right, ${item.value}, ${item.valueExt})`
            }"
          >
            <svg
              :class="{ 'svg-content': true, 'svg-content--active': index == checkedSpecItemId - 1 }"
              viewbox="0 0 100% 100%"
              preserveAspectRatio="none"
              v-if="isNoStore(index + 1)"
            >
              <rect
                class="svg-rect"
                stroke-dasharray="2"
                stroke-opacity="1"
                :x="remToPx(0.02)"
                :y="remToPx(0.02)"
                :rx="index == checkedSpecItemId - 1 ? remToPx(0.33) : remToPx(0.3)"
                :ry="index == checkedSpecItemId - 1 ? remToPx(0.33) : remToPx(0.3)"
                :style="{
                  fill: '#fff',
                  stroke: '#fff',
                  'stroke-width': remToPx(0.03),
                  'fill-opacity': 0.1
                }"
              ></rect>
            </svg>
            <i
              :id="`${checkedSpecItemId}-color`"
              class="color"
              :class="{
                color: true,
                'color--dark': isDarkColor(item.value, item.valueExt)
              }"
            >
              {{ item.name }}
            </i>
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import skuEventBus from '../sku-select/eventBus'
import { mapGetters } from 'vuex'
import env from 'utils/clientEnv'
export default {
  name: 'SkuColor',
  props: {
    spuInfo: null,
    show3D: false
  },
  data() {
    return {
      checkedSpecItemId: 0, // 选中规格值的id,
      availableSpecItems: [], // 知否有该规格项
      storeSpecItems: [] // 该规格项是否有库存
    }
  },
  computed: {
    ...mapGetters('detailv3', [
      // 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
      'goodsType',
      // 通用埋点数据
      'commonTrackData'
    ]),
    // 规格id数组
    specMain() {
      return this.spuInfo?.specItem?.specMain
    },
    // 规格项id
    specId() {
      let tempSpecId
      // 如果是手机，则一定有两个规格，第二个规格是颜色
      if (this.goodsType == 1) {
        tempSpecId = this.specMain[1]
      } else if (this.goodsType == 2) {
        const specNum = this.specMain.length
        if (specNum == 1) {
          // 如果只有一个规格，则一定为颜色（因为这是颜色组件）
          tempSpecId = this.specMain[0]
        } else if (specNum == 2) {
          Object.entries(this.spuInfo.specItem?.specMainSeq).forEach(item => {
            if (item[1] == '颜色') {
              tempSpecId = item[0]
            }
          })
        }
      }

      return tempSpecId
    },
    specName() {
      return this.spuInfo.specItem?.specMainSeq[this.specId]
    },
    // 规格id在specMain中的索引
    specIdIndex() {
      return this.specMain?.indexOf(this.specId)
    },
    // 可选选项
    specAvaiArr() {
      return this.availableSpecItems[this.specIdIndex] || []
    },
    // 有库存的选项
    specStoreArr() {
      return this.storeSpecItems[this.specIdIndex] || []
    },
    items() {
      return this.spuInfo?.specItem?.specItemSeq?.[this.specId]
    },
    trackData() {
      return {
        page_name: this.commonTrackData.page_name,
        sku_id: this.commonTrackData.sku_id,
        version_content: 1
      }
    }
  },
  watch: {
    checkedSpecItemId: {
      immediate: true,
      handler(specItemId, oldSpecItemId) {
        if (oldSpecItemId != undefined) {
          if (!document.body.scrollTo) {
            // 兼容安卓5.0
            Element.prototype.scrollTo = function (x, y) {
              this.scrollLeft = x
              this.scrollTop = y
            }
          }
          // 选中项变化后自动定位
          setTimeout(() => {
            // document.querySelector(`.color-item-${specItemId - 1}`)?.scrollIntoView({
            //   behavior: 'smooth',
            //   block: 'nearest',
            //   inline: 'center'
            // })
            /**
             * 1)先让选中的元素滚到可视区域的最左边 scrollLeft
             * 2)接着向右移动容器一半的距离 containWidth / 2
             * 3)最后向左移动item一半的距离 offsetWidth / 2
             */
            this.$nextTick(() => {
              let lastSpot = this.$refs.scrollBox.scrollLeft
              // 每次移动距离
              const nextSpace = 7
              let scrollItemTimer = setInterval(() => {
                let offsetWidth = document.querySelector(`.color-item-${specItemId - 1}`)?.offsetWidth
                let scrollLeft = document.querySelector(`.color-item-${specItemId - 1}`)?.offsetLeft
                const containWidth = this.$refs?.scrollBox?.offsetWidth
                // 最终要停留的点
                let resultSpot = scrollLeft + offsetWidth / 2 - containWidth / 2
                if (Math.abs(lastSpot - resultSpot) < nextSpace) {
                  clearInterval(scrollItemTimer)
                }
                if (resultSpot >= lastSpot) {
                  lastSpot = lastSpot + nextSpace
                } else {
                  lastSpot = lastSpot - nextSpace
                }
                this.$refs?.scrollBox?.scrollTo(lastSpot, 0)
              }, 15)
            })
          }, 0)
        }
      }
    }
  },
  created() {
    this.bindEvent()
    // 曝光埋点
    this.$track(
      Object.assign({}, this.trackData, {
        cfrom: '173|001|02|077',
        event_id: '173|001|02|077'
      })
    )
  },
  methods: {
    bindEvent() {
      // 规格项可选情况发生变化
      skuEventBus.$on('avaiSpecChange', (availableSpecItems, storeSpecItems) => {
        this.availableSpecItems = availableSpecItems
        this.storeSpecItems = storeSpecItems
      })
      // 规格项选中变化
      skuEventBus.$on('checkedSpecChange', ({ specId, specItemId, specName, specItemName }) => {
        if (specId == this.specId) {
          this.checkedSpecItemId = specItemId
        }
      })
    },
    selectColor(index, name) {
      // 如果已经选中，则不作操作
      if (this.checkedSpecItemId - 1 == index) return false
      // 通知sku组件选中该规格
      skuEventBus.$emit('selectSpecItem', {
        specId: this.specId,
        specItemId: index + 1,
        specName: this.specName,
        specItemName: name
      })
      // 点击埋点
      this.$track(
        Object.assign({}, this.trackData, {
          cfrom: '173|001|01|077',
          event_id: '173|001|01|077'
        })
      )
    },
    // 是否有该组合
    isExist(specItemId) {
      return this.specAvaiArr?.indexOf(specItemId + '') >= 0
    },
    // 是否下架或无库存
    isNoStore(specItemId) {
      return this.isExist(specItemId) && this.specStoreArr?.indexOf(specItemId + '') < 0
    },
    // 16进制转yuv模式，通过判断y值判断深浅色以设置不同的文字颜色
    isDarkColor(value1, value2) {
      const newValue1 = value1.replace('#', '')
      const newValue2 = (value2 || value1).replace('#', '')
      const r = ((parseInt(newValue1.substr(0, 2), 16) + parseInt(newValue2.substr(0, 2), 16)) / 2) * 0.299
      const g = ((parseInt(newValue1.substr(2, 2), 16) + parseInt(newValue2.substr(2, 2), 16)) / 2) * 0.587
      const b = ((parseInt(newValue1.substr(4, 2), 16) + parseInt(newValue2.substr(4, 2), 16)) / 2) * 0.114
      return r + g + b >= 210
    },
    // rem转px
    remToPx(rem) {
      // ios、安卓5.1下不兼容svg中使用rem，因此转为px，安卓6以上继续使用rem
      if (env.isIOS || env.androidLevel?.toFixed(0) < 6) {
        return (document.documentElement.clientWidth / 10.8) * rem + 'px'
      } else {
        return rem + 'rem'
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-1 {
  .sku-color .item_bg .color_item {
    line-height: 34px;
  }
}
.vivo-fontscale-4 {
  .sku-color .item_bg .color_item {
    line-height: 26px;
  }
}
.vivo-fontscale-5 {
  .sku-color .item_bg {
    .color_item {
      line-height: 20px;
    }
    &--active .color_item {
      line-height: 24px;
    }
  }
}
</style>
